/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Ad_Plugin_Update_FailedInputs */

const en_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error updating AD Plugin. ${i?.error}`)
};

const fr_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de la mise à jour du plug-in AD. ${i?.error}`)
};

const de_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Aktualisieren des AD-Plugins. ${i?.error}`)
};

const it_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'aggiornamento del plugin AD. ${i?.error}`)
};

const ru_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка обновления плагина AD. ${i?.error}`)
};

const es_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al actualizar el complemento de AD. ${i?.error}`)
};

const zh_cn2_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新广告插件时出错。${i?.error}`)
};

const ja_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ADプラグインの更新中にエラーが発生しました。${i?.error}`)
};

const hi_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD प्लगइन को अपडेट करने में त्रुटि। ${i?.error}`)
};

const pt_pt2_team_manager_ad_plugin_update_failed = /** @type {(inputs: Team_Manager_Ad_Plugin_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao atualizar o plug-in do AD. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error updating AD Plugin. {error}" |
*
* @param {Team_Manager_Ad_Plugin_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_ad_plugin_update_failed = /** @type {((inputs: Team_Manager_Ad_Plugin_Update_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Ad_Plugin_Update_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_ad_plugin_update_failed(inputs)
	if (locale === "de") return de_team_manager_ad_plugin_update_failed(inputs)
	if (locale === "it") return it_team_manager_ad_plugin_update_failed(inputs)
	if (locale === "ru") return ru_team_manager_ad_plugin_update_failed(inputs)
	if (locale === "es") return es_team_manager_ad_plugin_update_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_ad_plugin_update_failed(inputs)
	if (locale === "ja") return ja_team_manager_ad_plugin_update_failed(inputs)
	if (locale === "hi") return hi_team_manager_ad_plugin_update_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_ad_plugin_update_failed(inputs)
	return en_team_manager_ad_plugin_update_failed(inputs)
});